/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

interface SegmentDashboardUsageNoticeArgs {
  usage: number[];
}

export default class SegmentDashboardUsageNotice extends Component<SegmentDashboardUsageNoticeArgs> {
  @service auth!: AuthService;

  get currentUserIsMonitoringSegment() {
    return this.args.usage.includes(Number(this.auth.user?.id));
  }
}
